import { createFetchAction } from '@mews-commander/utils';

const EMAIL_SEND = 'EMAIL_SEND';

export const sendEmail =
    (values: $TSFixMe) =>
    (dispatch: $TSFixMe, getState: $TSFixMe, { container }: { container: () => CommanderContainer }) => {
        const { reservationIds, mailType, receiver, customEmail, preferredLanguageCode } = values;
        const { reservationComponent } = container();
        const promise = reservationComponent.sendEmail(
            reservationIds,
            mailType,
            receiver,
            customEmail,
            preferredLanguageCode
        );
        return dispatch(createFetchAction(EMAIL_SEND, promise));
    };
